import { Component, inject, input } from '@angular/core';

import { BaseComponent, BaseEditFormModalComponent, ModalService } from 'tms-lib';
import { AddressDetails, AddressService, CustomerAddressEdit, CustomerAddressService } from 'tms-web-shared';
import { AddressDetailsComponent } from '../address-details/address-details.component';

@Component({
  selector: 'app-customer-address-create-modal',
  templateUrl: './customer-address-create-modal.component.html',
  styleUrl: './customer-address-create-modal.component.scss',
  imports: [BaseEditFormModalComponent, AddressDetailsComponent],
})
export class CustomerAddressCreateModalComponent extends BaseComponent {
  protected readonly addressService = inject(AddressService);
  private readonly customerAddressService = inject(CustomerAddressService);
  private readonly modalService = inject(ModalService);

  public readonly id = input<string>();

  saved(model: AddressDetails) {
    const customerAddress = { addressId: model.id, customerId: this.id() } as CustomerAddressEdit;
    this.customerAddressService
      .save(customerAddress)
      .pipe(this.untilDestroyed())
      .subscribe(() => this.modalService.close(customerAddress));
  }
}
